import React from "react"
import { Calendar } from "lucide-react"

/**
 * Pinned drop-off location / date (above the accordion wizard).
 * Visual reference: SportOMSBootv2 OrderFormPage pinned drop-off card.
 * @param {{
 *   value: Record<string, unknown>,
 *   locations: Array<{ id: unknown, name?: unknown }>,
 *   onChange: (v: Record<string, unknown>) => void,
 *   locationSelectDisabled?: boolean,
 *   cardRef?: React.Ref<HTMLDivElement>,
 * }} props
 */
export default function DropoffSection({
    value,
    locations,
    onChange,
    locationSelectDisabled = false,
    cardRef,
    fieldErrors = null,
}) {
    const showErrors = fieldErrors != null
    return (
        <div
            ref={cardRef}
            className={`bg-white rounded border p-3 p-md-4${showErrors && (fieldErrors.locationId || fieldErrors.date) ? " border-danger" : ""}`}
            style={{ scrollMarginTop: "6rem" }}
        >
            <div className="row g-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="dropoff-location">
                        Drop-off Location<span className="text-danger ms-1">*</span>
                    </label>
                    <select
                        id="dropoff-location"
                        value={value.locationId == null ? "" : String(value.locationId)}
                        onChange={(e) => {
                            const raw = e.target.value
                            onChange({
                                ...value,
                                locationId: raw === "" ? null : Number(raw),
                            })
                        }}
                        className={`form-select${showErrors && fieldErrors.locationId ? " is-invalid" : ""}`}
                        disabled={locationSelectDisabled}
                    >
                        <option value="">Select a location</option>
                        {locations.map((location) => (
                            <option key={String(location.id)} value={String(location.id)}>
                                {String(location.name ?? "")}
                            </option>
                        ))}
                    </select>
                    {showErrors && fieldErrors.locationId ? (
                        <div className="text-danger small mt-1">{fieldErrors.locationId}</div>
                    ) : null}
                </div>

                <div className="col-12 col-md-6">
                    <label className="form-label d-flex align-items-center" htmlFor="dropoff-date">
                        Drop-off Date<span className="text-danger ms-1">*</span>
                        <Calendar className="text-muted ms-2" size={16} />
                    </label>
                    <input
                        id="dropoff-date"
                        type="date"
                        className={`form-control${showErrors && fieldErrors.date ? " is-invalid" : ""}`}
                        value={String(value.date ?? "")}
                        onChange={(e) => onChange({ ...value, date: e.target.value })}
                    />
                    {showErrors && fieldErrors.date ? (
                        <div className="text-danger small mt-1">{fieldErrors.date}</div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
